/**
 * Product Features section – Swiper init for mobile card carousel.
 * Loads Swiper when missing; inits all [data-product-features-swiper] instances.
 */
(function() {
  function initProductFeaturesSwiper(container) {
    if (typeof window.Swiper === 'undefined') return;
    const section = container.closest('.el-product-features-section');
    if (!section) return;
    const slider = section.querySelector('.el-product-features__slider');
    const pagination = section.querySelector('.el-product-features__pagination');
    if (!slider || !pagination || slider.swiper) return;
    new window.Swiper(slider, {
      loop: true,
      speed: 300,
      breakpoints: { 0: { slidesPerView: 1, spaceBetween: 0 }, 981: { slidesPerView: 3, spaceBetween: 24 } },
      pagination: { el: pagination, clickable: true },
      keyboard: { enabled: true, onlyInViewport: true }
    });
  }

  function runInits() {
    document.querySelectorAll('[data-product-features-swiper]').forEach((container) => {
      initProductFeaturesSwiper(container);
    });
  }

  if (typeof window.Swiper !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInits);
    else runInits();
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css';
  document.head.appendChild(link);
  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
  s.onload = function() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInits);
    else runInits();
  };
  document.head.appendChild(s);
})();
